import React from "react";
import { createRoot } from "react-dom/client";
import { KatSpinner } from "@amzn/katal-react";

import App from "./components/App";
import AppInitWrapper from "./components/AppInitWrapper";
import ErrorBoundary from "./components/ErrorBoundary";
import { initializePWA } from "./utils/pwaUtils";
import { cloudWatchLogger } from "./services/CloudWatchLoggerService";
import { consoleInterceptor } from "./utils/consoleInterceptor";

import "@amzn/katal-components/styles.css";
import "./index.scss";

// Initialize PWA features
initializePWA();

// Initialize CloudWatch Logger
// LoggerUrl is injected by webpack at build time
const loggerUrl = "https://yag4489qej.execute-api.us-east-1.amazonaws.com/prod/v1/log";

if (loggerUrl && !loggerUrl.startsWith('{{')) {
  cloudWatchLogger.initialize(loggerUrl);
  consoleInterceptor.initialize();
  console.log('[App] CloudWatch logger and console interceptor initialized - all console calls will be logged');
} else {
  console.warn('[App] LoggerUrl not configured, CloudWatch logging disabled');
}

// Flush logs before page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    cloudWatchLogger.forceFlush();
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppInitWrapper>
        <React.Suspense fallback={<KatSpinner size="large" />}>
          <App />
        </React.Suspense>
      </AppInitWrapper>
    </ErrorBoundary>
  </React.StrictMode>
);
